"use client";

import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export default function AlertModal() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  // useEffect(() => {
  //   setIsOpen(true);
  // }, []);
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="bg-white">
        <DialogHeader className="border-b pb-5">
          <DialogTitle className="text-2xl font-bold text-[#2E0D1E]">Atenção!</DialogTitle>
          <DialogDescription>
            Olá, Analista. Você ainda não foi atribuído a nenhuma loja. Por
            favor, entre em contato com o administrador para realizar a
            atribuição. Ele pode fazer isso acessando
            <strong> Menu {">"} Atribuição de Analista</strong> e vinculando
            você a uma loja.
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
